import { render, staticRenderFns } from "./ElectricityPrice.vue?vue&type=template&id=150a2773"
import script from "./ElectricityPrice.vue?vue&type=script&lang=js"
export * from "./ElectricityPrice.vue?vue&type=script&lang=js"
import style0 from "./ElectricityPrice.vue?vue&type=style&index=0&id=150a2773&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports